import createFetchActions from './createFetchActions';

const fetchUserActions = createFetchActions('SESSION_INFO_USER');
const updateUserNameAction = createFetchActions('UPDATE_USER_NAME');

export { fetchUserActions, updateUserNameAction };
